import React from 'react';

import { StepProps } from '@betterment/js-runtime';
import { Icon } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';
import { Box, CenteredWorkflowLayout, Heading, Text } from '@betterment/style-closet-react';

import { RequestValues } from './Controller';

import NotFound from '../Checking/components/NotFound';
import { trackClick } from '../features/track';
import Footer from '../Shared/components/Footer';
import { urlBuilder } from '../Shared/urlBuilder';

interface Props extends StepProps<RequestValues> {
  spendingAccountName: string;
}

export const JointAccountInvitationSuccess: React.FC<React.PropsWithChildren<Props>> = ({
  flowState,
  spendingAccountName,
}) => {
  const { invitedUser, accountId, isNewAccount, isProspectSecondary, firstName } = flowState.values;

  if ((!invitedUser && !isProspectSecondary) || !accountId) {
    return <NotFound />;
  }

  const invitedUserFirstName = isProspectSecondary ? firstName : invitedUser?.firstName;

  let headingCopy = `Your invite has been sent to ${invitedUserFirstName}`;
  if (isNewAccount) {
    headingCopy = 'Your Checking account has been created';
  }

  return (
    <CenteredWorkflowLayout title="Joint Checking signup">
      <CenteredWorkflowLayout.Slot name="content">
        <Box mb="6">
          <Icon name="CheckmarkCircle" size="large" color="icon.success" />
        </Box>
        <Heading variant="primary" mb="5">
          {headingCopy}
        </Heading>
        {isNewAccount && (
          <Box as="ul" pb="6" pl="6" mt="8">
            <Text as="li" m="0" pb="6">
              We'll send you an email when {invitedUserFirstName} successfully joins your account.
            </Text>
            <Text as="li" m="0">
              Your Betterment Visa&reg; Debit Card is now connected to both of your Checking accounts. It's currently
              set to spend from {spendingAccountName}, but you can always switch accounts in your Checking settings.
            </Text>
          </Box>
        )}
        {!isNewAccount && (
          <Text as="p" mb="9" mt="8">
            We'll send you an email when {invitedUserFirstName} successfully joins your account.
          </Text>
        )}
        <CenteredWorkflowLayout.Actions>
          <SambaAutoLink
            onClick={() => trackClick({ name: 'ViewPendingJCAccountPrimary', flow: 'OpenJointCheckingPrimary' })}
            to={urlBuilder.getAppCheckingSummary({ accountId })}
            variant="solidPrimary"
          >
            View your account
          </SambaAutoLink>
        </CenteredWorkflowLayout.Actions>
      </CenteredWorkflowLayout.Slot>
      <CenteredWorkflowLayout.Slot name="footer">
        <Footer />
      </CenteredWorkflowLayout.Slot>
    </CenteredWorkflowLayout>
  );
};

export default JointAccountInvitationSuccess;
